module.exports = __webpack_public_path__ + "static/media/b_point_bg.53592303.jpg";